import { z } from "zod";

export const backOfficeErrorSchema = z
  .object({
    code: z.string().nullish(),
    error: z.string().nullish(),
    message: z.string().nullish(),
    error_description: z.string().nullish(),
    messageCode: z.string().nullish(),
  })
  .refine((error) => Boolean(error.code ?? error.error ?? error.message ?? error.messageCode));

export const kiliFieldErrorDetailsSchema = z.object({
  fieldErrors: z
    .array(
      z.object({
        errorCode: z.string(),
        message: z.string(),
        propertyPath: z.string(),
      }),
    )
    .optional(),
  errorType: z.string().optional(),
  errorCode: z.string().optional(),
  message: z.string().optional(),
});

export const kiliErrorSchema = z.object({
  errorCategory: z.string(),
  errorDetails: kiliFieldErrorDetailsSchema,
});

export type TBackofficeError = z.infer<typeof backOfficeErrorSchema>;
export type TKiliError = z.infer<typeof kiliErrorSchema>;

export interface IBackofficeCustomError {
  title?: string;
  message?: string;
}

export interface IKiliFieldErrorDetail {
  propertyPath: string;
  errorCode: string;
}
